import { cloneDeep } from 'lodash/lang'
import { selectLocation } from 'lib/cart/services/selection'
import { findRetailCartProduct } from 'lib/cart/decorators/cartForm'

const setCartLocation = (state, action) => {
  const { camper, session, product, location } = action

  // clone cart products so we don't mutate state
  const cartForm = cloneDeep(state)

  // set selected location for the appropriate cart product
  selectLocation(location, {
    camper,
    session,
    product,
    cartForm
  })

  // clear selected dates when location changes (dates are location-specific)
  const cartProduct = findRetailCartProduct({ camper, session, cartForm })
  if (cartProduct && cartProduct.reservationDays) {
    cartProduct.reservationDays = []
    cartProduct.days = 0
  }

  // return a new state object
  return cartForm
}

export default setCartLocation
